import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MensajeDTO } from 'src/app/global/interfaces/general-response';
import { FirmaService } from 'src/app/global/services/firma.service';
import { FirmaServiceVM } from 'src/app/view-model/services/firma.service';

@Injectable()
export class FirmaProviderVM extends FirmaServiceVM {

    constructor(
        private firmaService: FirmaService
    ) {
        super();
    }

    public validStatusFirm(estado: string): Promise<MensajeDTO> {
        return this.firmaService.validStatusFirm(estado)
            .pipe(map(this.responseValidStatusFirm), catchError(this.serviceError)).toPromise();
    }

    private responseValidStatusFirm = (response) => response.mensaje;

    private serviceError(error) {
        return throwError(error);
    }
}
